import styles from "./Header.module.scss";
import notificationIcon from "../../assets/images/icons/notification.svg";
import { useState } from "react";
import { setProfileImage } from "../../helper/imagePaths";
import useAppSelector from "../../hooks/useAppSelector";
import { AuthService } from "../../services/auth.service";
import useAppDispatch from "../../hooks/useAppDispatch";
import { logout } from "../../store/userProfile/userProfileSlice";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [isOpenSelect, setIsOpenSelect] = useState(false);
  const { user } = useAppSelector((state) => state.userProfileSlice);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const clickOnSelect = () => {
    setIsOpenSelect(!isOpenSelect);
  };

  const clickOnLogout = () => {
    AuthService.logout();
    dispatch(logout());
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.right}>
          <img src={notificationIcon} alt={"notification"} />
          <div
            className={`${styles.select} ${isOpenSelect && styles.active}`}
            onClick={clickOnSelect}
          >
            <div
              className={styles.profileImage}
              style={{ backgroundImage: `url(${setProfileImage(user?.profileImagePath)})` }}
            ></div>
            <p className={styles.name}>
              {user?.firstname} {user?.lastname}
            </p>
            <svg
              className={styles.arrow}
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.2775 10.0275C8.0875 10.0275 7.8975 9.9575 7.7475 9.8075L4.2175 6.2775C3.9275 5.9875 3.9275 5.5075 4.2175 5.2175C4.5075 4.9275 4.9875 4.9275 5.2775 5.2175L8.2775 8.2175L11.2775 5.2175C11.5675 4.9275 12.0475 4.9275 12.3375 5.2175C12.6275 5.5075 12.6275 5.9875 12.3375 6.2775L8.8075 9.8075C8.6575 9.9575 8.4675 10.0275 8.2775 10.0275Z"
                fill="#292D32"
              />
            </svg>
            <div className={styles.box}>
              <ul className={styles.list}>
                <li className={styles.item} onClick={() => navigate("settings")}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_15133_17647)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.35548 1.8728C9.60215 1.69547 9.94881 1.6128 10.2895 1.73747C11.0137 2.00279 11.6864 2.39191 12.2775 2.88747C12.5555 3.1208 12.6575 3.46147 12.6268 3.7628C12.5768 4.2648 12.6648 4.74947 12.9068 5.1668C13.1201 5.53813 13.4415 5.83147 13.8335 6.03813L13.9835 6.11147C14.2595 6.23613 14.5048 6.49547 14.5668 6.85347C14.6985 7.61224 14.6985 8.38803 14.5668 9.1468C14.5115 9.46947 14.3068 9.71147 14.0648 9.84747L13.9835 9.88947C13.5235 10.0961 13.1475 10.4161 12.9061 10.8335C12.6648 11.2515 12.5768 11.7355 12.6268 12.2375C12.6568 12.5388 12.5555 12.8801 12.2775 13.1128C11.6864 13.6084 11.0137 13.9975 10.2895 14.2628C10.1347 14.3182 9.96868 14.3348 9.80599 14.3112C9.64329 14.2876 9.48884 14.2245 9.35615 14.1275C8.94548 13.8335 8.48081 13.6668 7.99881 13.6668C7.51681 13.6668 7.05215 13.8328 6.64215 14.1275C6.50938 14.2246 6.35481 14.2878 6.19199 14.3114C6.02916 14.335 5.86304 14.3183 5.70815 14.2628C4.98388 13.9975 4.31121 13.6084 3.72015 13.1128C3.59496 13.0064 3.49768 12.8711 3.4368 12.7185C3.37591 12.5659 3.35326 12.4008 3.37081 12.2375C3.42081 11.7355 3.33215 11.2508 3.09081 10.8335C2.87101 10.4609 2.54957 10.1586 2.16415 9.96213L2.01415 9.8888C1.86371 9.82217 1.73189 9.7197 1.6302 9.59035C1.52851 9.461 1.46005 9.30871 1.43081 9.1468C1.2991 8.38803 1.2991 7.61224 1.43081 6.85347C1.48615 6.5308 1.69081 6.2888 1.93281 6.1528L2.01415 6.11147C2.47415 5.90413 2.85015 5.5848 3.09148 5.1668C3.33215 4.74947 3.42081 4.2648 3.37081 3.7628C3.35326 3.59947 3.37591 3.43433 3.4368 3.28176C3.49768 3.12919 3.59496 2.99383 3.72015 2.88747C4.31122 2.39191 4.98389 2.00279 5.70815 1.73747C5.86295 1.68216 6.02894 1.66557 6.19163 1.68916C6.35432 1.71275 6.50876 1.7758 6.64148 1.8728C7.05148 2.16747 7.51615 2.33347 7.99881 2.33347C8.48148 2.33347 8.94548 2.16747 9.35548 1.8728ZM9.99348 3.05213C9.41615 3.43213 8.73548 3.6668 7.99881 3.6668C7.26215 3.6668 6.58148 3.43147 6.00415 3.05213C5.54004 3.23947 5.10464 3.49128 4.71081 3.80013C4.75081 4.4888 4.61415 5.19547 4.24615 5.83347C3.87748 6.4708 3.33415 6.94213 2.71748 7.25213C2.648 7.74793 2.648 8.251 2.71748 8.7468C3.33415 9.0568 3.87748 9.52813 4.24615 10.1668C4.61415 10.8035 4.75081 11.5101 4.71081 12.1988C5.1046 12.5079 5.54 12.7599 6.00415 12.9475C6.58148 12.5675 7.26215 12.3328 7.99881 12.3328C8.73548 12.3328 9.41615 12.5681 9.99348 12.9475C10.4576 12.7601 10.893 12.5083 11.2868 12.1995C11.2468 11.5101 11.3835 10.8035 11.7515 10.1661C12.1195 9.52813 12.6635 9.0568 13.2801 8.74613C13.3496 8.25078 13.3496 7.74816 13.2801 7.2528C12.6635 6.94213 12.1201 6.4708 11.7515 5.8328C11.3835 5.19547 11.2468 4.4888 11.2868 3.79947C10.893 3.49061 10.4576 3.23947 9.99348 3.05213ZM7.99881 5.33347C8.70606 5.33347 9.38434 5.61442 9.88443 6.11452C10.3845 6.61461 10.6655 7.29289 10.6655 8.00013C10.6655 8.70738 10.3845 9.38565 9.88443 9.88575C9.38434 10.3858 8.70606 10.6668 7.99881 10.6668C7.29157 10.6668 6.61329 10.3858 6.1132 9.88575C5.6131 9.38565 5.33215 8.70738 5.33215 8.00013C5.33215 7.29289 5.6131 6.61461 6.1132 6.11452C6.61329 5.61442 7.29157 5.33347 7.99881 5.33347ZM7.99881 6.6668C7.64519 6.6668 7.30605 6.80728 7.05601 7.05732C6.80596 7.30737 6.66548 7.64651 6.66548 8.00013C6.66548 8.35376 6.80596 8.69289 7.05601 8.94294C7.30605 9.19299 7.64519 9.33347 7.99881 9.33347C8.35244 9.33347 8.69157 9.19299 8.94162 8.94294C9.19167 8.69289 9.33215 8.35376 9.33215 8.00013C9.33215 7.64651 9.19167 7.30737 8.94162 7.05732C8.69157 6.80728 8.35244 6.6668 7.99881 6.6668Z"
                        fill="#323232"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_15133_17647">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  {t("Settings")}
                </li>
                <li className={styles.item} onClick={clickOnLogout}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_15133_17665)">
                      <path
                        d="M10.198 4.69984C10.136 4.76175 10.0868 4.83528 10.0533 4.91621C10.0197 4.99714 10.0025 5.08389 10.0025 5.1715C10.0025 5.25911 10.0197 5.34587 10.0533 5.4268C10.0868 5.50773 10.136 5.58126 10.198 5.64317L11.8887 7.33317H6C5.82319 7.33317 5.65362 7.40341 5.5286 7.52843C5.40357 7.65346 5.33333 7.82303 5.33333 7.99984C5.33333 8.17665 5.40357 8.34622 5.5286 8.47124C5.65362 8.59627 5.82319 8.6665 6 8.6665H11.8887L10.198 10.3572C10.073 10.4823 10.0028 10.6519 10.0029 10.8287C10.0029 11.0056 10.0732 11.1752 10.1983 11.3002C10.3234 11.4252 10.4931 11.4954 10.6699 11.4953C10.8468 11.4952 11.0163 11.4249 11.1413 11.2998L13.9693 8.47117C14.0943 8.34615 14.1645 8.17661 14.1645 7.99984C14.1645 7.82306 14.0943 7.65352 13.9693 7.5285L11.1413 4.69984C11.0794 4.63785 11.0059 4.58868 10.925 4.55513C10.844 4.52158 10.7573 4.50431 10.6697 4.50431C10.5821 4.50431 10.4953 4.52158 10.4144 4.55513C10.3334 4.58868 10.2599 4.63785 10.198 4.69984ZM2 12.6665C2 12.8433 2.07024 13.0129 2.19526 13.1379C2.32029 13.2629 2.48986 13.3332 2.66667 13.3332C2.84348 13.3332 3.01305 13.2629 3.13807 13.1379C3.2631 13.0129 3.33333 12.8433 3.33333 12.6665V3.33317C3.33333 3.15636 3.2631 2.98679 3.13807 2.86177C3.01305 2.73674 2.84348 2.6665 2.66667 2.6665C2.48986 2.6665 2.32029 2.73674 2.19526 2.86177C2.07024 2.98679 2 3.15636 2 3.33317V12.6665Z"
                        fill="#323232"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_15133_17665">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  {t("Logout")}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
